import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { LeadSubscriptionsQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

const leadSubscriptionsQuery = graphql(`
  query leadSubscriptions {
    leadSubscriptions {
      id
      destinationSettings {
        type
        name
        webhookUrl
      }
      frequency
      views {
        id
        name
        description
        dataType
        contentId
      }
    }
  }
`);

export function useLeadSubscriptions(
  options?: UseQueryOptions<LeadSubscriptionsQuery, unknown, LeadSubscriptionsQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(["leadSubscriptions"], leadSubscriptionsQuery, [], {
    ...options,
  });

  return { data: data?.leadSubscriptions, ...rest };
}
